var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownFilledTriangle = function SvgDownFilledTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "6px",
    viewBox: "0 0 9 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "#B5B5B5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    points: "4.5 6 9 0 0 0"
  }))));
};
export default SvgDownFilledTriangle;